<div
	class="flex lg:flex-row flex-col-reverse items-center gap-8 bg-surface-100 px-6 py-20 md:px-12 lg:px-20 dark:bg-surface-950 overflow-hidden">
	<div
		class="flex-1 flex flex-col gap-8"
		pAnimateOnScroll
		enterClass="animate-enter fade-in-10 slide-in-from-t-20 animate-duration-1000">
		<div class="flex-1 flex flex-col gap-4">
			<app-headline-large [title]="content.title"></app-headline-large>
			<app-body-large [description]="content.description"></app-body-large>
		</div>

		@if (content.copy.length > 0){
		<div class="flex gap-10 items-start">
			@for (item of content.copy; track item.title) {
			<div class="flex-1 flex flex-col gap-2 items-start">
				<h3
					class="text-surface-900 dark:text-surface-0 text-xl font-semibold leading-tight"
					[innerHTML]="item.title"></h3>
				<p
					class="text-surface-700 dark:text-surface-400 leading-normal mb-1"
					[innerHTML]="item.description"></p>
			</div>
			}
		</div>
		}
	</div>

	@if (content.image){
	<div
		class="lg:flex-1 w-full h-104 lg:h-144 xl:h-114 shadow"
		pAnimateOnScroll
		enterClass="animate-enter fade-in-10 slide-in-from-b-20 animate-duration-1000">
		<img
			loading="lazy"
			class="w-full h-full object-cover border-10 border-surface-0"
			[src]="content.image.src"
			[alt]="content.image.alt" />
	</div>
	}
</div>
